module.exports = {
          srcSet: __webpack_public_path__ + "d2600cd2.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "d2600cd2.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "d2600cd2.jpg",
          toString:function(){return __webpack_public_path__ + "d2600cd2.jpg"},
          
          width: 330,
          height: 200
        }